import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { ForgetPasswordGuard } from './core/guards/forget-password.guard';
import { PublicGuard } from './core/guards/public.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'transaction',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./pages/auth/login/login.module').then((m) => m.LoginPageModule),
    canLoad: [PublicGuard],
  },
  {
    path: 'signup',
    loadChildren: () =>
      import('./pages/auth/signup/signup.module').then(
        (m) => m.SignupPageModule
      ),
    canLoad: [PublicGuard],
  },
  {
    path: 'transaction',
    loadChildren: () =>
      import('./pages/transaction/transaction.module').then(
        (m) => m.TransactionPageModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: 'history',
    loadChildren: () =>
      import('./pages/history/history.module').then(
        (m) => m.HistoryPageModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: 'account',
    loadChildren: () =>
      import('./pages/account/account.module').then(
        (m) => m.AccountPageModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: 'my-points',
    loadChildren: () =>
      import('./pages/my-points/my-points.module').then(
        (m) => m.MyPointsPageModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: 'signup-verification-code',
    loadChildren: () =>
      import(
        './pages/auth/signup-verification-code/signup-verification-code.module'
      ).then((m) => m.SignupVerificationCodePageModule),
    canLoad: [PublicGuard],
  },
  {
    path: 'forget-password-verification-code',
    loadChildren: () =>
      import(
        './pages/auth/forget-password-verification-code/forget-password-verification-code.module'
      ).then((m) => m.ForgetPasswordVerificationCodePageModule),
    canLoad: [PublicGuard, ForgetPasswordGuard],
  },
  {
    path: 'forget-password-reset',
    loadChildren: () =>
      import(
        './pages/auth/forget-password-reset/forget-password-reset.module'
      ).then((m) => m.ForgetPasswordResetPageModule),
    canLoad: [PublicGuard, ForgetPasswordGuard],
  },
  {
    path: 'my-messages',
    loadChildren: () =>
      import('./pages/my-messages/my-messages.module').then(
        (m) => m.MyMessagesPageModule
      ),
  },
  {
    path: 'transaction-verification-code',
    loadChildren: () =>
      import(
        './shared/modals/transaction-verification-code/transaction-verification-code.module'
      ).then((m) => m.TransactionVerificationCodePageModule),
  },
  {
    path: 'view-agreement',
    loadChildren: () => import('./shared/modals/view-agreement/view-agreement.module').then(m => m.ViewAgreementPageModule)
  },
  {
    path: 'signup-more',
    loadChildren: () => import('./pages/auth/signup-more/signup-more.module').then(m => m.SignupMorePageModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'signup-idv',
    loadChildren: () => import('./pages/capture-id-photo/capture-id-photo.module').then(m => m.CaptureIdPhotoPageModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'signup-more-done',
    loadChildren: () => import('./pages/auth/signup-more-done/signup-more-done.module').then(m => m.SignupMoreDonePageModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'my-recipients',
    loadChildren: () =>
      import('./pages/account/pages/my-recipients/my-recipients.module').then(
        (m) => m.MyRecipientsPageModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: 'my-recipient-info',
    loadChildren: () =>
      import('./pages/account/pages/my-recipient-info/my-recipient-info.module').then(
        (m) => m.MyRecipientInfoPageModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: 'transaction-details',
    loadChildren: () => import('./pages/history/transaction-details/transaction-details.module').then(m => m.TransactionDetailsPageModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'forgot-pin',
    loadChildren: () =>
      import('./pages/account/pages/forgot-pin/forgot-pin.module').then(
        (m) => m.ForgotPinPageModule
      ),
    canLoad: [AuthGuard],
  },
  {
    path: 'schedules-reminder',
    loadChildren: () => import('./shared/modals/schedules-reminder/schedules-reminder.module').then(m => m.SchedulesReminderPageModule),
    canLoad: [AuthGuard],
  },
  {
    path: 't3',
    loadChildren: () => import('./pages/t3/t3.module').then(m => m.T3PageModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'referral',
    loadChildren: () => import('./pages/referral/referral.module').then(m => m.ReferralPageModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'promotions',
    loadChildren: () => import('./pages/promotions/promotions.module').then(m => m.PromotionsPageModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'capture-id-photo',
    loadChildren: () => import('./pages/capture-id-photo/capture-id-photo.module').then(m => m.CaptureIdPhotoPageModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'increase-limit',
    loadChildren: () => import('./pages/increase-limit/increase-limit.module').then(m => m.IncreaseLimitPageModule),
    canLoad: [AuthGuard],
  },
  {
    path: 'send-again',
    loadChildren: () => import('./shared/modals/send-again/send-again.module').then(m => m.SendAgainPageModule)
  },
  {
    path: 'send-again-review',
    loadChildren: () => import('./shared/modals/send-again-review/send-again-review.module').then(m => m.SendAgainReviewPageModule)
  },
  {
    path: 'send-again-done',
    loadChildren: () => import('./shared/modals/send-again-done/send-again-done.module').then(m => m.SendAgainDonePageModule)
  },

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
